import React from 'react'
import '../App.css';
import BodyEat from '../components/EatComponents';


function Eat() {
  return (
    <div>
      <BodyEat />
    </div>
  )
}

export default Eat
